export default {
  title: 'Análise da IA',
  empty: 'Nenhuma análise disponível',
  download: 'Baixar',
  print: 'Imprimir',
  period: 'Período',
  generatedAt: 'Gerado em',
};
